import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../../shared/NavBar';
import PageMetadata from '../../shared/PageMetadata';
import { PAGE_METADATA } from '../../pageMetadata';
import { attendancePath, attendanceTitle, attendanceLead, attendanceDownload, attendanceSections, attendanceLinks, attendanceSchema } from './attendanceRegisterContent';
import './SwitchJustGoPage.css';
import './AttendanceRegisterPage.css';

export default function AttendanceRegisterPage() {
 useEffect(() => {
  const link = document.createElement('link'); link.rel='canonical'; link.href='https://www.shuttleops.com'+attendancePath;
  document.head.appendChild(link); return () => link.remove();
 }, []);
 return <>
  <PageMetadata metadata={PAGE_METADATA[attendancePath]} />
  <script type="application/ld+json">{JSON.stringify(attendanceSchema)}</script>
  <header className="switch-hero attendance-hero"><NavBar /><div className="switch-hero__layout">
   <div><h1>{attendanceTitle}</h1><p>{attendanceLead}</p><a className="switch-start" href={attendanceDownload} download>Download the free register <span aria-hidden="true">↓</span></a></div>
   <figure className="attendance-preview"><figcaption>Club night, clearly recorded</figcaption><table><thead><tr><th>Player</th><th>Arrived</th><th>Payment</th></tr></thead><tbody><tr><td>Player A</td><td>Present</td><td>Paid</td></tr><tr><td>Player B</td><td>Present</td><td>Due</td></tr><tr><td>Player C</td><td>Absent</td><td>Unchecked</td></tr></tbody></table><p>Example entries. Your download starts blank.</p></figure>
  </div></header>
  <main className="switch-guide attendance-guide">
   {attendanceSections.map(section=><section className="switch-affiliation" key={section.title}><h2>{section.title}</h2>{section.steps && <ol className="attendance-steps">{section.steps.map(step=><li key={step.title}><h3>{step.title}</h3><p>{step.text}</p></li>)}</ol>}{section.paragraphs.map(text=><p key={text}>{text}</p>)}</section>)}
   <nav className="switch-related" aria-label="Related ShuttleOps pages"><h2>Take the next step</h2>{attendanceLinks.map(([href,label])=><Link to={href} key={href}>{label} →</Link>)}</nav>
  </main>
 </>;
}
